import {
  Dac6ReporterActions,
  OTHERS_TRANSMISSION_UPDATED,
  TransMissionUpdatedAction
} from '../actions/dac6-reporter.actions';

export interface IDac6ReporterState {
  item: any;
  updatedTransMission: any;
}

const initialState: IDac6ReporterState = <IDac6ReporterState>{
  item: {},
  updatedTransMission: {}
};

export function Dac6ReporterReducer(state = initialState, action: Dac6ReporterActions): IDac6ReporterState {
  switch (action.type) {
    case OTHERS_TRANSMISSION_UPDATED:
      const payload = (action as TransMissionUpdatedAction).payload;
      if (payload) {
        return <IDac6ReporterState>{...state, updatedTransMission: {...payload}};
      }
      break;
    default:
      return <IDac6ReporterState>{
        ...state
      };
  }
}

